import "../styles/PricingCard.css";
import formatCurrency from "../_utils/formatCurrency";
import { useNavigate } from "react-router-dom";

import { toBoolean } from "../_utils/to.boolean";

const PricingCard = ({ 
  plan, 
  productId,
  proceed
}) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    if(proceed.proceedTo !== "register") {
      navigate(`/business/?tenantId=${proceed.tenantId}&planId${plan.planId}&target=subscribe`, { state:{plan} })
    } else {
      navigate(`/register/${plan.productId}/${plan.planId}`, { state:{plan} })
    }
  }

  return (
    <div
      className={`card shadow-lg pricing-card ${
        toBoolean(plan.popular) ? "popular" : ""
      }`}
    >
      {toBoolean(plan.popular) && (
        <span className="pricing-badge">
          Most Popular
        </span>
      )}

      <h2 className={`${toBoolean(plan.popular) && "text-primary"}`}>
        {
          !productId
          ? plan.productName
          : ""
        }{" "}{plan.planName}
      </h2>

      {
        !productId && (
          <p><strong>Product Description: </strong> {" "} {plan.productDescription}</p>
        )
      }

      <p className="pricing-description">
        {plan.description}
      </p>

      <div className="pricing-price">
        <span className="currency">{plan.currency}</span>

        <span className="amount">
          {formatCurrency(plan.monthlyPrice, plan.currency, false)}
        </span>

        <span className="period">
          Monthly
        </span>
      </div>
      <div className="pricing-price">
        <span className="currency">{plan.currency}</span>

        <span className="amount">
          {formatCurrency(plan.annualPrice, plan.currency, false)}
        </span>

        <span className="period">
          Annual
        </span>
        
        <strong className=" m-2 text-primary">
          Save {formatCurrency(Number(plan.monthlyPrice) * 12 - Number(plan.annualPrice), plan.currency, true)}
        </strong>
      </div>
      <p className="pricing-description mb-0">
        May include training and other once-off charges
      </p>


      <button type="button" className="btn btn-primary" onClick={handleNavigate}>
        {
          proceed.proceedTo && proceed.tenantId 
          ? 
            <>
              Subscribe to {plan.planName}
            </>
          : 
            <>
              Register {plan.planName}
            </>
        }
      </button>

      <ul className="pricing-features">
        {plan.features.map((feature) => (
          <li key={feature.planFeatureId}>
            <p>{feature.featureName}:
              <span>
                {
                  feature.valueType === "boolean"
                  ? feature.valueBoolean 
                    ? <i className="bi bi-check-circle m-2 text-primary"></i> 
                    : <i className="bi bi-x-octagon m-2 text-danger"></i>
                  : feature.valueType === "integer"
                  ? <strong className="text-primary m-2">{feature.valueInteger}</strong> 
                  : feature.valueType === "decimal"
                  ? <strong className="text-primary m-2">{feature.valueDecimal}</strong> 
                  : <strong className="text-primary m-2">{feature.valueText}</strong> 
                }
              </span>
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PricingCard;